import type { EntityNoticePageKind, EntityNoticeVariant } from './params'

export interface PersistEntityNoticeInterestParams {
  email: string
  entityId: string
  variant: EntityNoticeVariant
  pageKind: EntityNoticePageKind | null
  source: string
}

/**
 * Fire-and-forget client call to the QA2-8c persist route. `device_id` is
 * deliberately not part of this signature — the server derives it from the
 * `jdid` cookie in a single place, so it never travels through the client.
 * A failure to emit must never block or break the terminal UI: this
 * function never throws, matching the spec's Criterion 3
 * (enforced -> measured).
 */
export async function persistEntityNoticeInterest(
  params: PersistEntityNoticeInterestParams
): Promise<void> {
  try {
    await fetch('/api/entity-notice/persist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    })
  } catch {
    // Swallowed by design — see the function doc comment above.
  }
}
